import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { TaxResidenceType } from '../../enums/TaxResidenceType.js';
class NationalityRequest extends BaseMessage {
    primary;
    primaryCountryCode;
    secondary;
    secondaryCountryCode;
}
__decorate([
    Field.string({
        description: 'Primary country name',
        required: false,
        pattern: "^[A-Za-zÅéôç,-\\.'’]+(\\s[A-Za-zÅéôç,-\\.'’()]+)*$",
    }),
    __metadata("design:type", String)
], NationalityRequest.prototype, "primary", void 0);
__decorate([
    Field.string({
        description: 'Primary country code',
        pattern: '^[A-Za-z\\s]*$',
        maxLength: 3,
    }),
    __metadata("design:type", String)
], NationalityRequest.prototype, "primaryCountryCode", void 0);
__decorate([
    Field.string({
        description: 'Secondary country name',
        pattern: "^[A-Za-zÅéôç,-\\.'’]+(\\s[A-Za-zÅéôç,-\\.'’()]+)*$",
    }),
    __metadata("design:type", String)
], NationalityRequest.prototype, "secondary", void 0);
__decorate([
    Field.string({
        description: 'Secondary country code',
        pattern: '^[A-Za-z\\s]*$',
        maxLength: 3,
    }),
    __metadata("design:type", String)
], NationalityRequest.prototype, "secondaryCountryCode", void 0);
class TaxResidentCountriesRequest extends BaseMessage {
    country;
    countryCode;
    isTINAvailable;
    tin;
    reasonForNoTin;
}
__decorate([
    Field.string({
        required: true,
        description: 'Tax resident country name',
        pattern: "^[A-Za-zÅéôç,-\\.'’]+(\\s[A-Za-zÅéôç,-\\.'’()]+)*$",
    }),
    __metadata("design:type", String)
], TaxResidentCountriesRequest.prototype, "country", void 0);
__decorate([
    Field.string({
        description: 'Tax resident country code',
        pattern: '^[A-Za-z\\s]*$',
        maxLength: 3,
    }),
    __metadata("design:type", String)
], TaxResidentCountriesRequest.prototype, "countryCode", void 0);
__decorate([
    Field.boolean({
        description: 'TIN number avilability',
        required: true,
    }),
    __metadata("design:type", Boolean)
], TaxResidentCountriesRequest.prototype, "isTINAvailable", void 0);
__decorate([
    Field.string({
        description: 'TIN number',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesRequest.prototype, "tin", void 0);
__decorate([
    Field.string({
        description: 'Reason for no TIN number',
    }),
    __metadata("design:type", String)
], TaxResidentCountriesRequest.prototype, "reasonForNoTin", void 0);
export class SetNationalityAndTaxResidentRequest extends BaseMessage {
    id;
    nationalities;
    taxResidence;
    taxResidentCountries;
    confirmTaxResidency;
    owner;
    isDualNationality;
}
__decorate([
    Field.string({
        description: 'Individual ID',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], SetNationalityAndTaxResidentRequest.prototype, "id", void 0);
__decorate([
    Field.message({
        description: 'Nationality list',
        required: false,
    }),
    __metadata("design:type", NationalityRequest)
], SetNationalityAndTaxResidentRequest.prototype, "nationalities", void 0);
__decorate([
    Field.enum({
        enum: TaxResidenceType,
        description: 'Tax Residencies',
    }),
    __metadata("design:type", String)
], SetNationalityAndTaxResidentRequest.prototype, "taxResidence", void 0);
__decorate([
    Field.array({
        required: false,
        items: {
            type: 'message',
            message: TaxResidentCountriesRequest,
        },
    }),
    __metadata("design:type", Array)
], SetNationalityAndTaxResidentRequest.prototype, "taxResidentCountries", void 0);
__decorate([
    Field.boolean({
        description: 'Confirm Tax Residency',
    }),
    __metadata("design:type", Boolean)
], SetNationalityAndTaxResidentRequest.prototype, "confirmTaxResidency", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], SetNationalityAndTaxResidentRequest.prototype, "owner", void 0);
__decorate([
    Field.boolean({
        description: 'dual nationality flag',
        required: false,
    }),
    __metadata("design:type", Boolean)
], SetNationalityAndTaxResidentRequest.prototype, "isDualNationality", void 0);
//# sourceMappingURL=SetNationalityAndTaxResidentRequest.js.map